























import {Component, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class FooterLinks extends Vue {
    public footerLinks = [
        {
            header: 'Services',
            items: [

                {path: '/services/hair-and-makeup-services', text: 'Hair & Makeup'},
                {path: '/services/hair-services', text: 'Hair'},
                {path: '/services/makeup-services', text: 'Makeup'},
                {path: '/weddings', text: 'Weddings'},
                {text: 'Galas & Award Shows', path: '/events'},
                {text: 'TV & Film', path: '/tv-and-film'},
                {text: 'Beauty Packages', path: '/packages'},
                {text: 'Gift Cards', path: '/gift-cards'},
            ],
        },
        {
            header: 'Cities We<br/>Currently Service',
            items: [
                {path: '/locations/new-york-city', text: 'New York City Metro'},
                {path: '/locations/new-jersey-metro-area', text: 'New Jersey Metro'},
                {path: '/locations/los-angeles-metro-area', text: 'Los Angeles Metro'},
                {path: '/locations/las-vegas', text: 'Las Vegas Metro'},
                {path: '/locations/salt-lake-city', text: 'Salt Lake City Metro'},
                {path: '/locations/chicago', text: 'Chicago Metro'},
            ],
        },
        {
            header: 'Client Resources',
            items: [
                {path: '/login', text: 'Client Resource Area'},
                {path: '/about', text: 'About SoPlush Beauty'},
                {path: '/services', text: 'SoPlush Services & Products'},
                {path: '/faqs', text: 'Frequently Asked Questions'},
                {path: '/privacy-policy', text: 'Privacy Policy'},
                {path: '/terms-of-service', text: 'Terms of Service'},
            ],
        },
        {
            header: 'Team Resources',
            items: [
                {path: '/become-a-pro', text: 'Careers'},
                {path: '/login', text: 'Pros Login'},
            ],
        },
        {
            header: '',
            icons: true,
            items: [
                {path: 'https://www.instagram.com/soplushtoyou/', icon: 'fab fa-instagram'},
                {path: 'https://twitter.com/soplushbeauty', icon: 'fab fa-twitter'},
                {path: 'https://www.youtube.com/channel/UC2zU6Dci_ZSRwXs0d6kAeYA', icon: 'fab fa-youtube'},
                {path: 'https://www.yelp.com/biz/soplush-beauty-las-vegas-2', icon: 'fab fa-yelp'},
                {
                    path: 'https://www.theknot.com/marketplace/soplush-beauty-las-vegas-nv-2022571',
                    icon: 'fas fa-ring',
                },
            ],
        },
    ];
}
